import { render, staticRenderFns } from "./TwoColumnMenu.vue?vue&type=template&id=4ff09428&"
import script from "./TwoColumnMenu.vue?vue&type=script&lang=js&"
export * from "./TwoColumnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports